import { Component, Input } from "@angular/core";

@Component({
  selector: "app-icon-email",
  imports: [],
  templateUrl: "./icon-email.component.html",
  styleUrl: "./icon-email.component.scss",
})
export class IconEmailComponent {
  @Input() color: string = "#fff";
}
